// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__h0JTe","amount":"Amount_amount__25-Rj","tip":"Amount_tip__1-F9p","tipHeader":"Amount_tipHeader__3y9Zu","tipsWrap":"Amount_tipsWrap__87ygF"};